/* Leagues Cup 2026: hero background slideshow.
   Cross-fades the stacked .lc-hero-slide images inside .parallax-wrap.
   Vanilla JS, no deps.

   Design notes:
   - Only opacity changes, so the parallax transform on the wrapper and the
     Ken Burns zoom on the images keep running untouched.
   - Honours prefers-reduced-motion: the first frame stays put, no cycling.
   - Pauses when the tab is hidden or the hero has scrolled out of view, so we
     never burn a compositor layer on a hero nobody is looking at.
   - Lazy slides are decoded before their first reveal to avoid a flash of
     empty box on slow connections.
*/
(function () {
  "use strict";

  var reduce =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initSlideshow(root) {
    var slides = root.querySelectorAll(".lc-hero-slide");
    if (slides.length < 2) return;

    var interval = parseInt(root.getAttribute("data-hero-interval"), 10);
    if (isNaN(interval) || interval < 2000) interval = 6000;

    var index = 0;
    var timer = null;
    var visible = true;
    var onScreen = true;

    /* Decode the off-screen frames up front so the first cross-fade is clean. */
    for (var i = 1; i < slides.length; i++) {
      var img = slides[i];
      if (img.decode) {
        img.decode().catch(function () {});
      }
    }

    function show(next) {
      if (next === index) return;
      slides[index].classList.remove("is-active");
      slides[index].setAttribute("aria-hidden", "true");
      slides[next].classList.add("is-active");
      slides[next].removeAttribute("aria-hidden");
      index = next;
    }

    function advance() {
      show((index + 1) % slides.length);
    }

    function start() {
      if (timer || reduce) return;
      if (!visible || !onScreen) return;
      timer = window.setInterval(advance, interval);
    }

    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    document.addEventListener("visibilitychange", function () {
      visible = !document.hidden;
      if (visible) start();
      else stop();
    });

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          onScreen = entries[0].isIntersecting;
          if (onScreen) start();
          else stop();
        },
        { threshold: 0.01 }
      );
      io.observe(root);
    }

    start();
  }

  function boot() {
    var roots = document.querySelectorAll("[data-hero-slides]");
    for (var i = 0; i < roots.length; i++) initSlideshow(roots[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  /* Shopify theme editor: re-init when the hero section is re-rendered. */
  document.addEventListener("shopify:section:load", function (e) {
    var roots = e.target.querySelectorAll
      ? e.target.querySelectorAll("[data-hero-slides]")
      : [];
    for (var i = 0; i < roots.length; i++) initSlideshow(roots[i]);
  });
})();
